import classNames from 'classnames';
import {
  PropertyBlock,
  FlexContainer,
  Tabs,
  PartialWidthContainer,
  Button,
  Icon,
} from 'components';
import { observer } from 'mobx-react-lite';
import { Outlet, useNavigate } from 'react-router-dom';
import { useProperty } from 'state';
import styles from './PropertyViewLayout.module.scss';

const tabsOptions = [
  {
    key: 'manage',
    path: 'manage',
    value: 'Manage',
  },
  {
    key: 'tenancies',
    path: 'tenancies',
    value: 'Tenancies',
  },
];

/**
 * PropertyViewLayout
 *
 * @return {JSX.Element}
 */
const PropertyViewLayout = () => {
  const navigate = useNavigate();
  const property = useProperty();

  const { data: dataState } = property;

  const handleBack = () => {
    navigate('/properties', { replace: true });
  };

  return (
    <PartialWidthContainer
      className={classNames(
        styles.PropertyViewLayout,
        `${PropertyViewLayout.displayName}`
      )}
      flex
      column
      small
      gap
    >
      <FlexContainer>
        <Button onClick={handleBack}>
          <Icon s name="goback" /> Back
        </Button>
      </FlexContainer>
      <FlexContainer column>
        <PropertyBlock
          className={styles.PropertyBlock}
          imageUrls={dataState.imageUrls}
          bathroomCount={dataState.bathroomCount}
          bedroomCount={dataState.bedroomCount}
          postcode={dataState.address.postcode}
          name={dataState.address.name}
        />
        <Tabs className={styles.Tabs} options={tabsOptions} asNav />
      </FlexContainer>
      <FlexContainer column flex gap>
        <FlexContainer column flex>
          <Outlet />
        </FlexContainer>
      </FlexContainer>
    </PartialWidthContainer>
  );
};

PropertyViewLayout.displayName = 'PropertyViewLayout';

export default observer(PropertyViewLayout);
